import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Stack, Button, Box, Chip, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import AceEditor from "react-ace";
import 'brace/ext/searchbox';
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import toast, { Toaster } from 'react-hot-toast';
import HelpIcon from '@mui/icons-material/HelpOutline';


const CommonProgramCode = props => {
    const navigate = useNavigate();
    const [value, setValue] = useState('');
    const [modified, setModified] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        if (props.project_id) {
            client.request_get('/project/' + props.project_id).then(res => {
                if (res.common_javascript)
                    setValue(res.common_javascript)
                else
                    setValue('')
                
                setLoading(false)
            })
        }
    }, [props.project_id])

    function useKey(key, cb) {
        const callback = useRef(cb);

        useEffect(() => {
            callback.current = cb;
        })


        useEffect(() => {
            function handle(event) {
                if (event.code === key) {
                    callback.current(event);
                } else if (key === 'ctrls' && event.key === 's' && (event.ctrlKey || event.metaKey)) {
                    callback.current(event);
                    event.preventDefault();
                    return true
                }
            }

            document.addEventListener('keydown', handle);
            return () => document.removeEventListener("keydown", handle)
        }, [key])
    }

    useKey('ctrls', () => {
        if(loading || !modified)
            return

        toast.promise(
            getSavePromise(),
            {
                loading: 'Saving...',
                success: <b>Saved!</b>,
                error: <b>Could not save.</b>,
            }
        );
    });

    const save = () => {
        if(loading)
            return
        toast.promise(
            getSavePromise(),
            {
                loading: 'Saving...',
                success: <b>Saved!</b>,
                error: <b>Could not save.</b>,
            }
        );
    }

    const getSavePromise = () => {
        return new Promise((resolve, reject) => {
            client.request_post('/api/project/script/' + props.project_id, { common_javascript: value }).then(res => {
                setModified(false)
                resolve();
            })
        })
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Toaster
                position="bottom-center"
                reverseOrder={false}
            />

            <Stack direction={"row"} spacing={1} sx={{
                    height: '50px',
                    maxWidth: '40vw',
                    alignItems: 'center',
                    overflow: 'auto',
                    paddingLeft: '10px',
                }}>
                <Typography variant="h7"> Project Common Code</Typography>
            </Stack>
            <AceEditor
                onChange={(newValue) => { setValue(newValue); setModified(true) }}
                width={'100%'}
                height={props.height ? props.height : 'calc(100% - 100px)'}
                placeholder={props.label}
                mode="javascript"
                theme="github"
                name="blah2"
                wrapEnabled={true}
                // onChange={newValue=>{handleChange(newValue)}}
                fontSize={14}
                showPrintMargin={true}
                showGutter={true}
                highlightActiveLine={true}
                value={value}
                setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: true,
                    tabSize: 2,
                }} />

            <Box sx={{
                width: '100%',
                height: '50px',
            }}>
                <Divider />
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px',
                    paddingRight: '10px',
                    justifyContent: 'space-between',
                }}>
                    <Button variant="contained" disabled={!modified || loading} onClick={save} >Save</Button>
                </Box>
            </Box>
        </Box>
    );
};

export default CommonProgramCode;
